export default __webpack_public_path__ + "static/media/logo-cfm.84fd33ea.png";